module.exports = __webpack_public_path__ + "img/Stemness-CRC_10X_WTA.ff91d575.png";